export default [
  {
    path: '',
    name: 'apps-control-list',
    component: () => import(/* webpackChunkName: "apps-control-list" */ '@/apps/control/pages/FormPage.vue'),
    meta: {
      layout: 'content',
    },
  },
]
